export default {
    version:'v0.9',// 版本号
    apiTimeout: 15000,
    lang: 'zh',// zh 中文 en 英文
    appId:'992021030901240071',// 应用id,不需要修改
    systemName:'鸿鑫社区商城',
}
